import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MenuComponent } from './menu';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'desktop-fixed-menu',
  templateUrl: './desktop-fixed-menu.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule,
    TranslocoModule,
    PipesModule,
    RouterModule]
})
export class DesktopFixedMenuComponent extends MenuComponent {
  merchant_code: string;

  constructor() {
    super();
    // Access _config through the protected/public property from base class
    // We need to change _config to protected in MenuComponent
    this.merchant_code = this._config.CONFIG.merchant_code;
  }
}
